import { defineStore } from 'pinia';
import { getAllModels } from '@/api/cms';
import { ModelState } from './types';

const useModelStore = defineStore('models', {
  state: () => ({
    models: [] as ModelState[], // 模型列表
    loading: false,
  }),

  getters: {
    // 根据 name 获取某个模型
    getModelByName: (state) => {
      return (name: string) => state.models.find((m) => m.name === name);
    },
  },

  actions: {
    // 获取模型列表
    async fetchModels() {
      this.loading = true;
      try {
        const { data } = await getAllModels();
        this.models = data?.list || [];
        // } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});

export default useModelStore;
